import type { JSX } from "react";

import { Button, Flex } from "@mantine/core";

import { CorrectAnswer } from "./icons";
import CompletedBadge from "./icons/CompletedBadge.svg";
import classes from "./MicroLearning.module.css";

type CompletedQuizProps = {
    onClickClose: () => void;
};

export function CompletedQuiz({ onClickClose }: CompletedQuizProps): JSX.Element {
    return (
        <Flex className={classes.question} gap="md" pb="md">
            <img data-testid="completed-badge-animation" src={CompletedBadge} alt="" height={144} />
            <Flex direction={"column"} w="100%">
                <Flex gap="3xs" pt="xl" fz="xl" fw={700}>
                    <CorrectAnswer />
                    Congrats!
                </Flex>
                <Flex pt="xxs">You’ve earned a new badge.</Flex>
                <Flex justify={"flex-end"}>
                    <Button w={85} size="xs" onClick={onClickClose}>
                        Got it!
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    );
}
